export default "__VITE_ASSET__BDRej$oP__"